<template lang="html">
  <div class="start">
    <div class="text">
      <h1>Build on Volkswagen</h1>
      <div class="startButton">
        <a @click="clearCookies"><div class="buttons" type="button" name="button"><span>Start</span>  </div></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    clearCookies() {
    	window.kp_Browser_clearCookies();
      setTimeout(function(){
        window.location.href ="/"
      },500)
    }
  }
}
</script>

<style lang="scss" scoped>
  .start{
    width: 100%;
    height: 100vh;
    text-align: center;
    position: relative;
    .text{
      height: 100px;
      position: absolute;
      top:0;
      bottom:0;
      left:0;
      right:0;
      margin: auto;
      h1{
        font-size: 3rem;
      }
      .startButton{
          display: flex;
          justify-content: center;
          margin-top: 20px;
          .buttons{
            padding: .8rem 2rem;
            background: white;
            border-radius: 40px;
            margin: 0 .6rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            height: 60px;
            border-radius: 30px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
              color:black;
              background: #3e3e3e;
              color:rgb(205, 205, 205);
              border-radius: 30px;
              box-shadow: 0 10px 10px -10px rgba(0,0,0,.1);
              padding: 1rem 2rem;
              text-transform: uppercase;
              font-family:  'Union Regular',Helvetica, Arial, sans-serif;;
              font-weight:  normal;
              font-style:   normal;
              font-stretch: normal;
            }
          }

      }
    }
  }
</style>
